module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid37_820x961.e347156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid37_820x961.jpg
// module id = s99k
// module chunks = 0